import React from 'react'

import { OptionProps, useInputOptions } from '../Hooks/useInputOptions'
import { Radio, RadioProps } from '../Radio'

type SafeProps = Omit<RadioProps, keyof OptionProps | 'children'>

export type RadioGroupProps = OptionProps & SafeProps

export const RadioGroup = (props: RadioGroupProps) => {
  const { options, selected } = useInputOptions(props)
  const { options: _, value, ...filteredProps } = props

  return (
    <>
      {options.map(option => (
        <Radio
          {...filteredProps}
          key={option.value}
          onChange={() => props.onChange(option.value)}
          checked={selected === option}>
          {option.label}
        </Radio>
      ))}
    </>
  )
}
